import { OrderApi } from '@ps/api/order';
import { CreateOrderDtoV3PaymentTypeEnum } from '@ps/api/types';
import { withClientAPI } from '@ps/functions/utils/api';

export async function bookGroupEvent(params: {
  storeId: string;
  listingId: string;
  groupEventId: string;
  startDate: string;
  endDate: string;
  timezone: string;
}): Promise<void> {
  const orderApi = withClientAPI(OrderApi);

  await orderApi.orderApiControllerCreateOrderInMultiCurrency({
    CreateOrderDtoV3: {
      sellerId: params.storeId,
      listingId: params.listingId,
      quantity: 1,
      paymentType: CreateOrderDtoV3PaymentTypeEnum.Empty,
      buyerName: 'PopStore Buyer',
      requestTrackingID: crypto.randomUUID(),
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
      returnUrl: window.location.href,
      groupEvent: {
        startDate: params.startDate,
        endDate: params.endDate,
        timezone: params.timezone,
        listingId: params.listingId,
        groupEventId: params.groupEventId,
      },
    },
  });
}
